module.exports = __webpack_public_path__ + "img/flowers-8175044_1280_thumb.0b44b0e9.png";